import { render } from "./StudentImport.vue?vue&type=template&id=2ae3642c&scoped=true&ts=true"
import script from "./StudentImport.vue?vue&type=script&lang=ts"
export * from "./StudentImport.vue?vue&type=script&lang=ts"

import "./StudentImport.vue?vue&type=style&index=0&id=2ae3642c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae3642c"]])

export default __exports__